import { Button } from "@flixbus/honeycomb-react";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { commonPathnames } from "../../../../../helper";

type Props = {
  primary: boolean;
};

const OpenTicketLoginButton: React.FC<Props> = ({ primary }) => (
  <Button
    data-id="ticket-login-button"
    appearance={primary ? "primary" : undefined}
    href={commonPathnames.serviceDeskRequestLogin}
    Elem="a"
  >
    <FormattedMessage id="serviceDesk.button.text" />
  </Button>
);

export default OpenTicketLoginButton;
